<!-- Profile Sidebar -->
<div class="h-100" data-aos="fade-up" data-aos-duration="800">
    <div class="profile-sidebar posSticky">
        <div class="py-2">
            <li class="nav-item align-items-center d-flex mx-2 my-3 justify-content-center">
                <a class="nav-link btn-fill btn-w-h100 w-50" (click)="routeLogin()">
                    {{ "NavBar.LogIn" | translate }}
                </a>
            </li>
            <li class="nav-item align-items-center d-flex mx-2 my-3 justify-content-center">
                <a class="nav-link btn-fill-light btn-w-h100 w-50" [routerLink]="'/' + app?.languageCode +'/Register'">{{
                    "NavBar.SignUp"
                    | translate
                    }}</a>
            </li>
        </div>
    </div>
</div>